import Vue from 'vue'
import VueI18n, { I18nOptions } from 'vue-i18n'
import messages from './messages'

const options: I18nOptions = {
  messages,
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  locale: 'en'
}

Vue.use(VueI18n)

export default new VueI18n(options)
